import { useCallback, useEffect, useRef, useState } from 'react';
import api from '../../Component/axios_Interceptor/api';
import api2 from '../../Component/axios_Interceptor/api2';
import { SERVER_ADDRESS } from '../../Component/server';

export type LiveQa = { id: string; messageId: string; nickname: string; question: string; answer: string; isCommon: number; createdAt: string; updatedAt: string };
export const LIVE_QA_URL = `${SERVER_ADDRESS}realtime/live-qa`;
export const LIVE_QA_EVENT = 'fanbird:live-qa-updated';
export function qaUpdated(liveSeq: number) { window.dispatchEvent(new CustomEvent(LIVE_QA_EVENT, { detail: { liveSeq } })); }
export function qaError(error: any) {
  const message = error?.response?.data?.message;
  return typeof message === 'string' ? message : Array.isArray(message) ? message.join(' ') : 'Q&A를 처리하지 못했습니다. 다시 시도해주세요.';
}

export function useLiveQa(liveSeq: number, scope: 'mine' | 'common' | 'manage', enabled: boolean, authenticated = true) {
  const [items, setItems] = useState<LiveQa[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const request = useRef(0);
  const refresh = useCallback(async (silent = false) => {
    if (!enabled) return;
    const version = ++request.current;
    if (!silent) setLoading(true);
    try {
      const { data } = await (authenticated ? api : api2).get(LIVE_QA_URL, { params: { liveSeq, scope } });
      if (version !== request.current) return;
      if (!Array.isArray(data)) throw new Error('Invalid Q&A list');
      setItems(data); setError('');
    } catch (failure) { if (version === request.current) setError(qaError(failure)); }
    finally { if (version === request.current) setLoading(false); }
  }, [liveSeq, scope, enabled, authenticated]);
  useEffect(() => {
    setItems([]); setError(''); setLoading(false);
    if (!enabled) return;
    void refresh();
    const update = (event: Event) => { if ((event as CustomEvent).detail?.liveSeq === liveSeq) void refresh(true); };
    const focus = () => { if (!document.hidden) void refresh(true); };
    window.addEventListener(LIVE_QA_EVENT, update); window.addEventListener('focus', focus);
    const timer = window.setInterval(focus, 15000);
    return () => { request.current++; window.clearInterval(timer); window.removeEventListener(LIVE_QA_EVENT, update); window.removeEventListener('focus', focus); };
  }, [enabled, liveSeq, scope, refresh]);
  return { items, loading, error, refresh };
}
